module.exports = "<p *ngFor=\"let room of rooms | async\">\n  {{room.name}}, {{room.id}}\n</p>\n"